var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"scan qr code\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.3726 6.40242V9.10237C10.3726 9.59942 9.95269 10.0024 9.43476 10.0024H6.62139C6.10346 10.0024 5.68359 9.59942 5.68359 9.10237V6.40242C5.68359 5.90538 6.10346 5.50244 6.62139 5.50244H9.43476C9.95269 5.50244 10.3726 5.90538 10.3726 6.40242Z",
    stroke: "#407BFF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.68359 14.499H10.3726",
    stroke: "#407BFF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.7539 14.499V18.9989",
    stroke: "#407BFF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.0664 23.5005H19.7554",
    stroke: "#407BFF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.0664 14.5265L15.0911 14.499",
    stroke: "#407BFF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M24.4453 14.5265L24.47 14.499",
    stroke: "#407BFF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M15.0664 19.0274L15.0911 19",
    stroke: "#407BFF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M24.4453 19.0274L24.47 19",
    stroke: "#407BFF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M24.4453 23.5279L24.47 23.5005",
    stroke: "#407BFF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M15.0664 10.0275L15.0911 10",
    stroke: "#407BFF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M15.0664 5.52991L15.0911 5.50244",
    stroke: "#407BFF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M10.3726 19.9V22.5999C10.3726 23.097 9.95269 23.4999 9.43476 23.4999H6.62139C6.10346 23.4999 5.68359 23.097 5.68359 22.5999V19.9C5.68359 19.4029 6.10346 19 6.62139 19H9.43476C9.95269 19 10.3726 19.4029 10.3726 19.9Z",
    stroke: "#407BFF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M24.4429 6.40242V9.10237C24.4429 9.59942 24.0231 10.0024 23.5051 10.0024H20.6917C20.1737 10.0024 19.7539 9.59942 19.7539 9.10237V6.40242C19.7539 5.90538 20.1737 5.50244 20.6917 5.50244H23.5051C24.0231 5.50244 24.4429 5.90538 24.4429 6.40242Z",
    stroke: "#407BFF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M24.4453 1H29.1343V5.49991",
    stroke: "#407BFF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M24.4453 28.0004H29.1343V23.5005",
    stroke: "#407BFF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M5.68896 1H1V5.49991",
    stroke: "#407BFF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M5.68896 28.0004H1V23.5005",
    stroke: "#407BFF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr_code.bde3542e14d76c0bf7d89b78f0f8adfe.svg";
export { ForwardRef as ReactComponent };